import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = {
  id: "header-container",
  ref: "headerContainer",
  class: "sticky top-0 z-60"
}
const _hoisted_3 = {
  ref: "mainContainer",
  class: "flex-grow flex-shrink-0 flex flex-row"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "sidebar-left",
  class: "contents"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  id: "sidebar-right",
  class: "contents"
}, null, -1)
const _hoisted_6 = {
  id: "footer-container",
  ref: "footerContainer",
  class: "sticky bottom-0 z-20"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "guard-modal-holder" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryNav = _resolveComponent("PrimaryNav")!
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")!
  const _component_TertiaryNav = _resolveComponent("TertiaryNav")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_InitialLoad = _resolveComponent("InitialLoad")!
  const _component_ScreenDimensionsDialog = _resolveComponent("ScreenDimensionsDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showNavigationBars)
          ? (_openBlock(), _createBlock(_component_PrimaryNav, {
              key: 0,
              onLogout: _ctx.logout
            }, null, 8, ["onLogout"]))
          : _createCommentVNode("", true),
        (_ctx.showNavigationBars)
          ? (_openBlock(), _createBlock(_component_SecondaryNav, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.showNavigationBars)
          ? (_openBlock(), _createBlock(_component_TertiaryNav, { key: 2 }))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.showMainElement)
          ? (_openBlock(), _createElementBlock("main", {
              key: 0,
              class: _normalizeClass([{ 'min-h-screen': !_ctx.showNavigationBars }, "flex-auto bg-black-50 min-w-0"])
            }, [
              _createVNode(_component_RouterView)
            ], 2))
          : _createCommentVNode("", true),
        _hoisted_5
      ], 512),
      _createElementVNode("div", _hoisted_6, null, 512),
      _hoisted_7
    ], 512), [
      [_vShow, _ctx.loaded]
    ]),
    _createVNode(_component_InitialLoad, { loaded: _ctx.loaded }, null, 8, ["loaded"]),
    (_ctx.showScreenDimensionDialog)
      ? (_openBlock(), _createBlock(_component_ScreenDimensionsDialog, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}